/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './lab-test-item-organism-antibiotic.reducer';

export const LabTestItemOrganismAntibiotic = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const labTestItemOrganismAntibioticList = useAppSelector(state => state.labTestItemOrganismAntibiotic.entities);
  const loading = useAppSelector(state => state.labTestItemOrganismAntibiotic.loading);
  const totalItems = useAppSelector(state => state.labTestItemOrganismAntibiotic.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="lab-test-item-organism-antibiotic-heading" data-cy="LabTestItemOrganismAntibioticHeading">
        <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.home.title">Lab Test Item Organism Antibiotics</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/lab-test-item-organism-antibiotic/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.home.createLabel">
              Create new Lab Test Item Organism Antibiotic
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.labTestItemOrganismAntibiotic.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {labTestItemOrganismAntibioticList && labTestItemOrganismAntibioticList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('suggestedBy')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.suggestedBy">Suggested By</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('suggestedBy')} />
                </th>
                <th className="hand" onClick={sort('micSusceptible')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.micSusceptible">Mic Susceptible</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('micSusceptible')} />
                </th>
                <th className="hand" onClick={sort('micIntermediate')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.micIntermediate">Mic Intermediate</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('micIntermediate')} />
                </th>
                <th className="hand" onClick={sort('micResistant')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.micResistant">Mic Resistant</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('micResistant')} />
                </th>
                <th className="hand" onClick={sort('notes')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.notes">Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('notes')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.source">Source</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.labTestItem">Lab Test Item</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.organism">Organism</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.antibiotic">Antibiotic</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.lab">Lab</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {labTestItemOrganismAntibioticList.map((labTestItemOrganismAntibiotic, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/lab-test-item-organism-antibiotic/${labTestItemOrganismAntibiotic.id}`} color="link" size="sm">
                      {labTestItemOrganismAntibiotic.id}
                    </Button>
                  </td>
                  <td>{labTestItemOrganismAntibiotic.suggestedBy}</td>
                  <td>{labTestItemOrganismAntibiotic.micSusceptible}</td>
                  <td>{labTestItemOrganismAntibiotic.micIntermediate}</td>
                  <td>{labTestItemOrganismAntibiotic.micResistant}</td>
                  <td>{labTestItemOrganismAntibiotic.notes}</td>
                  <td>{labTestItemOrganismAntibiotic.active ? 'true' : 'false'}</td>
                  <td>{labTestItemOrganismAntibiotic.cursor}</td>
                  <td>{labTestItemOrganismAntibiotic.lastUpdated}</td>
                  <td>{labTestItemOrganismAntibiotic.microSec}</td>
                  <td>{labTestItemOrganismAntibiotic.timestampEntry}</td>
                  <td>
                    {labTestItemOrganismAntibiotic.source ? (
                      <Link to={`/clinical-dictionary/${labTestItemOrganismAntibiotic.source.id}`}>
                        {labTestItemOrganismAntibiotic.source.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {labTestItemOrganismAntibiotic.labTestItem ? (
                      <Link to={`/lab-test-item/${labTestItemOrganismAntibiotic.labTestItem.id}`}>
                        {labTestItemOrganismAntibiotic.labTestItem.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {labTestItemOrganismAntibiotic.organism ? (
                      <Link to={`/organism/${labTestItemOrganismAntibiotic.organism.id}`}>{labTestItemOrganismAntibiotic.organism.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {labTestItemOrganismAntibiotic.antibiotic ? (
                      <Link to={`/antibiotic/${labTestItemOrganismAntibiotic.antibiotic.id}`}>
                        {labTestItemOrganismAntibiotic.antibiotic.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {labTestItemOrganismAntibiotic.lab ? (
                      <Link to={`/diag-lab/${labTestItemOrganismAntibiotic.lab.id}`}>{labTestItemOrganismAntibiotic.lab.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/lab-test-item-organism-antibiotic/${labTestItemOrganismAntibiotic.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/lab-test-item-organism-antibiotic/${labTestItemOrganismAntibiotic.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/lab-test-item-organism-antibiotic/${labTestItemOrganismAntibiotic.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.labTestItemOrganismAntibiotic.home.notFound">
                No Lab Test Item Organism Antibiotics found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={labTestItemOrganismAntibioticList && labTestItemOrganismAntibioticList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default LabTestItemOrganismAntibiotic;
